import { camelize } from 'casing'
import type { CloudMarketplace } from '../../productsListing/types'
import { mapPrivateOffer } from './mapPrivateOffer'

export const processPrivateOffers = async ({
  cloudMarketplace,
  response,
}: {
  cloudMarketplace: CloudMarketplace
  response: any
}) => {
  if (cloudMarketplace !== 'AZURE' && cloudMarketplace !== 'GCP') {
    return {
      ...response?.data.private_offers,
      free_tier_info: response?.data?.free_tier_info,
    }
  }
  let updatedOffers
  const responseData = camelize(response?.data)
  if (cloudMarketplace === 'AZURE') {
    updatedOffers = responseData?.privateOffers.map((offerItem: any) => {
      const mappedOffer = mapPrivateOffer(offerItem, 'id')
      return {
        ...mappedOffer,
        labraProductId:
          mappedOffer.labraProductId ||
          mappedOffer.cloudProductId ||
          mappedOffer.awsProductId,
      }
    })
  } else {
    updatedOffers = responseData?.privateOffers.rows.map((offerItem: any) =>
      mapPrivateOffer(offerItem, 'labraOfferId')
    )
  }
  const privateOffers = {
    rows: updatedOffers,
    pageNumber: responseData?.pageNumber ?? 0,
    pageSize: responseData?.pageSize ?? 10,
    totalCount: responseData?.totalCount ?? 0,
    sortBy: responseData?.sortBy ?? '',
    sortOrder: responseData?.sortOrder ?? 'desc',
    links: responseData?.links ?? {},
    freeTierInfo: responseData?.freeTierInfo,
  }

  return privateOffers
}
